import { render, staticRenderFns } from "./ChildrenSpouseForm.vue?vue&type=template&id=49d6ebca&scoped=true&"
import script from "./ChildrenSpouseForm.vue?vue&type=script&lang=js&"
export * from "./ChildrenSpouseForm.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenSpouseForm.vue?vue&type=style&index=0&id=49d6ebca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6ebca",
  null
  
)

export default component.exports